import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.artclassesineastcroydon.co.uk";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

/**
 * <Seo /> — drop into any page to set the document title, meta description,
 * canonical URL and Open Graph tags. Keeps Google + social shares tidy.
 */
export default function Seo({ title, description, path = "", image = DEFAULT_IMG, type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | Seasons Art Class — East Croydon` : "Seasons Art Class — East Croydon | Adult art classes";
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
